<template>
    <div>
        <el-radio-group v-model="radio1" class="tab">
            <el-radio-button label="单台设备入库"></el-radio-button>
            <el-radio-button label="批量设备入库"></el-radio-button>
        </el-radio-group>
        <el-form v-show="radio1=='批量设备入库'" :model="rule" :rules="rules" ref="forms" class="demo-ruleForm" label-width="100px">
            <el-form-item label="设备列表" prop="file">
                <input type="file" name="file" @change="getFile($event)">
            </el-form-item>
            <el-form-item label="硬件版本" prop="hardVersion">
                <el-input placeholder="请输入硬件版本" v-model="rule.hardVersion" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit">提交</el-button>
                <el-button @click="block">返回</el-button>
            </el-form-item>
        </el-form>
        <el-form v-show="radio1=='单台设备入库'" :model="rule2" :rules="rules2" ref="forms2" class="demo-ruleForm" label-width="100px">
            <el-form-item label="设备号" prop="devId">
                <el-input placeholder="请输入设备号" v-model="rule2.devId" clearable></el-input>
            </el-form-item>
            <el-form-item label="硬件版本" prop="hardVersion">
                <el-input placeholder="请输入硬件版本" v-model="rule2.hardVersion" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit2">提交</el-button>
                <el-button @click="block">返回</el-button>
            </el-form-item>
        </el-form>
    </div>
    
</template>

<script>
    export default {
        data() {
            return {
                name: 'edit',
                radio1: '单台设备入库',
                rule: {
                    file: [],
                    hardVersion:'',
                },
                rules: {
                    file: { required: true, message: '请上传文件' },
                    hardVersion: { required: true, message: '请输入硬件版本' },
                },
                rule2: {
                    devId: '',
                    hardVersion:'',
                },
                rules2: {
                    devId: { required: true, message: '请输入设备号' },
                    hardVersion: { required: true, message: '请输入硬件版本' },
                },
            }
        },
        methods: {
            submit() {
                this.$refs['forms'].validate(valid => {
                    if(valid) {
                        let headers = {
                            'Content-Type': 'multipart/form-data'
                        };
                        let formData = new FormData();
                        formData.append('file',this.rule.file);
                        formData.append('hardVersion',this.rule.hardVersion);
                        formData.append('hardVersion',this.rule.useStatus);
                        this.$http.post('/manage/stock/inStock',formData,{headers:headers}).then(rs => {
                            if(rs.data.code == 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                                this.$router.push('/inventory/put');
                            }else {
                                this.rule.file = '';
                                this.$message({
                                    message: rs.data.message,
                                    type: 'error'
                                });
                            }
                        })
                    }
                });
            },
            submit2() {
                this.$refs['forms2'].validate(valid => {
                    if(valid) {
                        this.$http.post('/manage/stock/inStockSingle',this.rule2).then(rs => {
                            if(rs.data.code == 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                                this.$router.push('/inventory/put');
                            }else {
                                this.$message({
                                    message: rs.data.message,
                                    type: 'error'
                                });
                            }
                        })
                    }
                });
            },
            block() {
                this.$router.push('/inventory/put');
            },
            getFile(event){
                var file = event.target.files;
                for(var i = 0;i<file.length;i++){
                    //    上传类型判断
                    var imgName = file[i].name;
                    var idx = imgName.lastIndexOf(".");  
                    if (idx != -1){
                        var ext = imgName.substr(idx+1).toUpperCase();   
                        ext = ext.toLowerCase(); 
                        this.rule.file = file[i];
                    }
                }
            },
        }
    }
</script>
<style scoped>
.tab{margin-bottom: 20px; margin-left: 100px;}
</style>